import React from 'react'
import useResizeObserver from './useResizeObserver'
import useHandlerDebounced from './useHandlerDebounced'

/**
 * Get contentRect from a node
 * @param {Object} ref - React reference of the node to observe
 * @param {Number} debounced - number of milliseconds used to debounce the resize callback
 *
 * @return {DOMRect} the node ref and its content rect
 */
export default function useContentRect(ref, debounced) {
  // initialize contentRect
  const [contentRect, setContentRect] = React.useState({})

  // create the debounced callback
  const onResize = useHandlerDebounced(debounced)(([{ target }]) =>
    setContentRect(target.getBoundingClientRect().toJSON())
  )

  // init ResizeObserver
  useResizeObserver(ref, onResize)

  // return hook result
  return contentRect
}
